module.exports = __webpack_public_path__ + "static/img/human-services.ceeaebc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/human-services.png
// module id = 4/2K
// module chunks = 1